import { FileInfo } from '@applyboard/crystal-ui';
import { DestinationForm } from './workflow/destination/types';
import { EducationSummaryForm } from './workflow/educationSummary/types';
import { AgreementAndConsentLead, DestinationLead } from './workflow/personalInformationLead/types';

export enum EnglishTest {
  TOEFL = 'TOEFL',
  IELTS = 'IELTS',
  PTE = 'PTE',
  DUOLINGO = 'Duolingo',
}

export type EnglishExamScores = {
  englishTestType: string;
  englishReadingScore?: string;
  englishWritingScore?: string;
  englishListeningScore?: string;
  englishSpeakingScore?: string;
  englishOverallScore?: string;
  englishDateOfExam?: string;
  englishTestScoreDocument?: FileInfo[];
};

export interface Student {
  firstName: string;
  lastName: string;
  emailAddress: string;
  contactPhoneNumber: string;
  contactWhatsAppNumber?: string;
  nationality: string;
}

export interface LoanData {
  student: Student;
  destinationLeadDetails?: DestinationLead;
  destinationDetails?: DestinationForm;
  educationSummary?: EducationSummaryForm;
  agreementAndConsent?: AgreementAndConsentLead;
  recruitmentPartnerId?: string;
  source?: string;
  id?: string;
}

export interface LoansFormStepProp {
  formValues?: LoanData;
}

export enum LoansFormEvents {
  PageView = 'Loans Form - Page View',
  StartedForm = 'Loans Form - Started Form',
  CompletedDestination = 'Loans Form - Completed Destination',
  CompletedDocumentUpload = 'Loans Form - Completed Document Upload',
  CompletedEducationSummary = 'Loans Form - Completed Education Summary',
  SubmissionValidationErrored = 'Loans Form - Submission Validation Errored',
  SubmissionErrored = 'Loans Form - Submission Errored',
  SubmissionCompleted = 'Loans Form - Submission Completed',
  LeadSubmissionErrored = 'Loans Form - Lead Submitted - Submission Errored',
  LeadSubmissionCompleted = 'Loans Form - Lead Submitted - Submission Completed',
  CheckDuplicateErrored = 'Loans Form - Check Duplicate Errored',
  InvalidSchoolName = 'Loans Form - Invalid School Name',
}
